import React from 'react'
import ReactMarkdown from 'react-markdown'
import renderers from './customRenderers'

// eslint-disable-next-line
export const parseEula = (eula, titleClass, textClass) => 
    (<ReactMarkdown
        renderers={renderers}
        source={eula}
        className={`${titleClass}|${textClass}`}
    />)



// WEBPACK FOOTER //
// ./src/features/Eula/markdown/parser.js